/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import validate from 'validate.js';
import moment from 'moment';
import * as selectorsControleFrequencias from '../../../store/controleFrequencia/reducer';
import * as actionsControleFrequencias from '../../../store/controleFrequencia/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Role from '../../../constants/role';
import {
  DialogDefaultV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
} from '../../../components/v2';
import { convertTimeToMinutes, isNullOrUndefined, isValidTime, formatToTime } from 'utils';

const defaultSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ocorrenciaId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspetor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const validateInvalidTimes = (values) => {
  let errors = {};

  if (!isNullOrUndefined(values.inicioJornada) && !isValidTime(values.inicioJornada)) {
    errors = { ...errors, inicioJornada: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.inicioIntervalo) && !isValidTime(values.inicioIntervalo)) {
    errors = { ...errors, inicioIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalIntervalo) && !isValidTime(values.finalIntervalo)) {
    errors = { ...errors, finalIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalJornada) && !isValidTime(values.finalJornada)) {
    errors = { ...errors, finalJornada: ['Horário inválido'] };
  }

  return errors;
};

const hasError = (values, horaExtraDisabled) => {
  let schema = defaultSchema;
  if (!horaExtraDisabled) {
    schema = {
      ...schema,
      horaExtraAutorizadoPor: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      horaExtraJustificativa: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  return {
    ...validate(values, schema),
    ...validateInvalidTimes(values),
  };
};

const Formulario = ({
  open,
  id,
  onClose,
  loadControleFrequencia,
  controleFrequencia,
  saveControleFrequencia,
  authData,
  adminPermission,
}) => {
  const [readOnly, setReadOnly] = useState(!adminPermission);
  const [errors, setErrors] = useState({});
  const [horaExtraDisabled, setHoraExtraDisabled] = useState(true);
  const [values, setValues] = useState({
    data: moment().valueOf(),
    tipoControle: 'FOLHA_PONTO',
    inspetor: !adminPermission ? authData?.id : null,
  });

  const validateHoraExtra = (data, jornadaTotalMinutes) => {
    if (data) {
      const day = (new Date(data)).getDay();
      if (day === 0) {
        setHoraExtraDisabled(false);
        return;
      }
    }

    if (!jornadaTotalMinutes || !data) {
      setHoraExtraDisabled(true);
      return;
    }

    const day = (new Date(data)).getDay();
    let nextHoraExtraDisabled = true;
    if (day === 0) {
      nextHoraExtraDisabled = false;
    } else if (day === 6) {
      nextHoraExtraDisabled = jornadaTotalMinutes <= 4 * 60;
    } else {
      nextHoraExtraDisabled = jornadaTotalMinutes <= 8 * 60;
    }

    setHoraExtraDisabled(nextHoraExtraDisabled);
  };

  useEffect(() => {
    if (id) loadControleFrequencia(id);
  }, [id, loadControleFrequencia]);

  useEffect(() => {
    if (id && controleFrequencia && id === controleFrequencia.id) {
      setValues({
        ...controleFrequencia,
        data: moment(parseInt(controleFrequencia.data, 10)).valueOf(),
      });
      setReadOnly(!adminPermission && controleFrequencia.criadoPor !== authData.id);
      validateHoraExtra(
        moment(parseInt(controleFrequencia.data, 10)).valueOf(),
        controleFrequencia.jornadaTotalMinutes,
      );
    } else {
      setValues({
        data: moment().valueOf(),
        tipoControle: 'FOLHA_PONTO',
        inspetor: !adminPermission ? authData?.id : null,
      });
      setReadOnly(false);
      setHoraExtraDisabled(true);
    }
  }, [controleFrequencia, id, adminPermission, authData?.id]);

  const onSave = () => {
    const erros = hasError(values, horaExtraDisabled);
    if (erros != null && Object.keys(erros).length > 0) {
      setErrors(erros);
      return;
    }
    saveControleFrequencia(values, () => onCloseLocal(true));
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({
      data: moment().valueOf(),
      tipoControle: 'FOLHA_PONTO',
      inspetor: !adminPermission ? authData?.id : null,
    });
    setReadOnly(false);
    setHoraExtraDisabled(true);
    onClose(isSave);
  };

  const onChange = (e, field) => {
    const value = e.target.value;

    const inicioJornadaMinutes = convertTimeToMinutes(field === 'inicioJornada' ? value : values.inicioJornada);
    const inicioIntervaloMinutes = convertTimeToMinutes(field === 'inicioIntervalo' ? value : values.inicioIntervalo);
    const finalIntervaloMinutes = convertTimeToMinutes(field === 'finalIntervalo' ? value : values.finalIntervalo);
    const finalJornadaMinutes = convertTimeToMinutes(field === 'finalJornada' ? value : values.finalJornada);

    const first = (inicioJornadaMinutes && inicioIntervaloMinutes && inicioIntervaloMinutes > inicioJornadaMinutes)
      ? inicioIntervaloMinutes - inicioJornadaMinutes
      : null;
    const second = (finalJornadaMinutes && finalIntervaloMinutes && finalJornadaMinutes > finalIntervaloMinutes)
      ? finalJornadaMinutes - finalIntervaloMinutes
      : null;
    const jornadaTotal = first !== null || second !== null ? (first || 0) + (second || 0) : null;

    const nextValues = {
      ...values,
      [field]: value,
      jornadaTotal: jornadaTotal ? formatToTime(jornadaTotal) : null,
      jornadaTotalMinutes: jornadaTotal,
    };

    setValues(nextValues);
    validateHoraExtra(nextValues.data, jornadaTotal);
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Ponto Diário"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            onChange={(data) => {
              setValues({ ...values, data });
              validateHoraExtra(data, values.jornadaTotalMinutes);
            }}
            value={values.data}
            isRequired
            error={!!(errors && errors.data)}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <OptionSelectV2
            label="Ocorrência"
            codigo="PONTO_OCORRENCIA"
            isRequired
            error={!!(errors && errors.ocorrenciaId)}
            onSelect={(ocorrenciaId) => setValues({ ...values, ocorrenciaId })}
            value={values.ocorrenciaId}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Usuário"
            onSelect={(inspetor) => setValues({ ...values, inspetor })}
            isRequired
            error={!!(errors && errors.inspetor)}
            value={values.inspetor}
            disabled={readOnly || !adminPermission}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Parceiro"
            onSelect={(inspetorAuxiliar) => setValues({ ...values, inspetorAuxiliar })}
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetorAuxiliar}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputFormatV2
            label="Inicio Jornada"
            value={values.inicioJornada}
            onChange={(e) => onChange(e, 'inicioJornada')}
            format="##:##"
            placeholder="HH:MM"
            disabled={readOnly}
            isRequired
            error={!!(errors && errors.inicioJornada)}
            helperText={errors && errors.inicioJornada ? errors.inicioJornada : null}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputFormatV2
            label="Inicio Intervalo"
            value={values.inicioIntervalo}
            onChange={(e) => onChange(e, 'inicioIntervalo')}
            format="##:##"
            placeholder="HH:MM"
            disabled={readOnly}
            error={!!(errors && errors.inicioIntervalo)}
            helperText={errors && errors.inicioIntervalo ? errors.inicioIntervalo : null}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputFormatV2
            label="Final Intervalo"
            value={values.finalIntervalo}
            onChange={(e) => onChange(e, 'finalIntervalo')}
            format="##:##"
            placeholder="HH:MM"
            disabled={readOnly}
            error={!!(errors && errors.finalIntervalo)}
            helperText={errors && errors.finalIntervalo ? errors.finalIntervalo : null}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputFormatV2
            label="Final Jornada"
            value={values.finalJornada}
            onChange={(e) => onChange(e, 'finalJornada')}
            format="##:##"
            placeholder="HH:MM"
            disabled={readOnly}
            error={!!(errors && errors.finalJornada)}
            helperText={errors && errors.finalJornada ? errors.finalJornada : null}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Hora Extra Autorizado Por"
            onSelect={(horaExtraAutorizadoPor) => setValues({
              ...values,
              horaExtraAutorizadoPor,
            })}
            grupos={[Role.ADMIN, Role.SUPER_ADMIN]}
            value={values.horaExtraAutorizadoPor}
            disabled={horaExtraDisabled || readOnly}
            isRequired={!horaExtraDisabled}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Justificativa Hora Extra"
            name="horaExtraJustificativa"
            onChange={(event) => setValues({
              ...values,
              horaExtraJustificativa: event.target.value,
            })}
            value={values.horaExtraJustificativa || ''}
            rows={3}
            multiline
            disabled={horaExtraDisabled || readOnly}
            isRequired={!horaExtraDisabled}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadControleFrequencia: PropTypes.func.isRequired,
  controleFrequencia: PropTypes.object,
  saveControleFrequencia: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
  adminPermission: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  controleFrequencia: selectorsControleFrequencias.getSelectedControleFrequencia(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsControleFrequencias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
